import { Link as RouterLink } from "react-router-dom";
import { Link } from "@mui/material";

export const LinkButton = ({ to, children, state, onClick, ...props }) => {
 if (!to) return null;

 return (
  <Link
   component={RouterLink}
   to={to}
   state={state}
   onClick={onClick}
   variant="body2"
   {...props}
  >
   {children}
  </Link>
 );
};
